(function () {
    "use strict";

    cc_Config.interviewButtonOptions = {
        showOnTop: false
    };

    cc_EntityIntegration.createDefaultScreen = function () {
        return '<div id="cloudcase-form-container">' +
            '<div id="cloudcase-page-navigator">' +
            '<ul id="cloudcase-page-navigator-unrestricted"></ul>' +
            '<ul id="cloudcase-page-navigator-restricted"></ul>' +
            '</div>' +
            '<div id="cloudcase-page-container">' +
            '<div id="page">' +
            '<div id="page-content" class="panel-group"></div>' +
            '</div>' +
            '</div>' +
            '</div>';
    };

    cc_EntityIntegration.getQuestions = function (allowFindingsGeneration, task, callback) {
        if (cip_Entity.onPreGetQuestions) {
            cip_Entity.onPreGetQuestions(cip_Common.brandId, cip_Common.formId, cc_Config.application, task);
        }

        cc_Ajax.serialRequest({
            url: cip_Common.toApplicationUrl() + '/' + cc_Config.applicationId + '/interview/edit',
            type: 'POST',
            throbberDelay: task && task.isUserDriven === false ? 10000 : 800,
            data: function () {
                return {
                    answeredQuestions: cc_Util.stringify(cc_Renderer.dettachQuestions(), cc_Config.uploadCompression.answeredQuestions),
                    allowFindingsGeneration: allowFindingsGeneration
                }
            },
            cleanSkippedResponse: function (response) {
                if (response && response.selectedApplication && response.selectedApplication.detail && response.selectedApplication.detail.interview) {
                    response.selectedApplication.detail.interview.findingsRegenerated = false;
                }
            },
            handle: function (response) {
                if (response.unexpectedOutcome) {
                    cip_Common.handleUnexpectedOutcome(response);

                } else {
                    cc_Model.isInterviewComplete = false;

                    if (response && response.selectedApplication && response.selectedApplication.detail) {
                        cc_Model.isInterviewComplete = response.selectedApplication.detail.submissionStatus == "SUBMISSION_COMPLETE";
                    }
                    
                    if (response && response.selectedApplication && response.selectedApplication.operation) {
                    	cc_Model.updateInterviewMode(response.selectedApplication.operation);
                    }

                    var interview = null;

                    if (response.selectedApplication) {
                        cc_Config.application = response.selectedApplication.detail;
                        cc_Config.workflowName = cc_Config.application.workflowName;
                        cc_Config.rulebookName = cc_Config.application.rulebookName;
                        cc_Config.rulebookVersion = cc_Config.application.rulebookVersion;
                        cc_Config.serverVersionOnRulebookSave = cc_Config.application.interview.serverVersionOnRulebookSave;

                        interview = cc_Config.application.interview;
                    }

                    cc_Controller.handleGetQuestionResponse(interview, task, callback);

                    if (task && task.triggerType === "SAVE") {
                        cip_Entity.showApplicationSaveAsDialog(cip_Common.brandId, cip_Common.formId, cc_Config.application);
                    }
                }
            }
        });
    };

    cc_EntityIntegration.addDocumentToQuestion = function (applicationId, questionId, form) {
        var options = {
            type: 'POST',
            data: {},
            useShortThrobberKey: true,
            url: cip_Common.toApplicationUrl() + '/' + applicationId + '/add/question/' + questionId + '/document',
            handle: function (response) {
                if (response.unexpectedOutcome) {
                    cip_Common.handleUnexpectedOutcome(response);

                } else {
                    if (response.invalidInputs && response.invalidInputs.length > 0) {
                        // only show the first error if there is more than one
                        cc_Renderer.attachError(questionId, response.invalidInputs[0].description, "server");
                    } else {
                        var task = {
                            triggerType: "ADD_DOCUMENT",
                            manuallySelectedPageId: null,
                            enableMoveToRelativePage: false,
                            isUserDriven: false,
                            focusedQuestionId: cc_UI.getFocusedQuestionId()
                        };

                        cc_Controller.handleResponse(response.selectedApplication.detail.interview, task);
                    }
                }
            }
        };

        // we need to add manually since form.ajaxSubmit does not used the
        // $.ajaxSetup defaults
        options = $.extend({}, cc_Ajax.defaults, options);

        // increase timeout for slow internet connections
        options.timeout = 1000 * 60 * 5; // 5 mins;

        form.ajaxSubmit(options);
    };

    cc_EntityIntegration.removeDocumentFromQuestion = function (applicationId, questionId, documentId, successCallback) {
        cc_Ajax.serialRequest({
            url: cip_Common.toApplicationUrl() + '/' + applicationId + '/delete/question/' + questionId + '/document/' + documentId,
            type: 'POST',
            data: {},
            handle: function (response) {
                if (response.unexpectedOutcome) {
                    cip_Common.handleUnexpectedOutcome(response);

                } else {
                    var task = {
                        triggerType: "REMOVE_DOCUMENT",
                        manuallySelectedPageId: null,
                        enableMoveToRelativePage: false,
                        isUserDriven: false,
                        focusedQuestionId: cc_UI.getFocusedQuestionId()
                    };
                    cc_Controller.handleResponse(response.selectedApplication.detail.interview, task);
                }
            }
        });
    };

    cc_EntityIntegration.saveUnsubmittedApplicationToCompleteLater = function (applicationId, email, mobilePhoneNumber, successCallback) {
        $.ajax({
            url: cip_Common.toApplicationUrl() + '/' + applicationId + '/save/completelater',
            type: 'POST',
            data: {
                email: email,
                mobilePhoneNumber: mobilePhoneNumber,
            },
            handle: function (response) {
                if (response.unexpectedOutcome) {
                    cip_Common.handleUnexpectedOutcome(response);

                } else {
                    successCallback(response);
                }
            }
        });
    };

    cc_EntityIntegration.sendApplicantSessionActivationSmsCode = function (successCallback) {
        $.ajax({
            url: cip_Common.toApplicationUrl() + '/authentication/sms/send',
            type: 'POST',
            data: {},
            handle: function (response) {
                if (response.unexpectedOutcome) {
                    cip_Common.handleUnexpectedOutcome(response);

                } else {
                    successCallback(response);
                }
            }
        });
    };

    cc_EntityIntegration.activateApplicantSessionUsingSmsCode = function (smsCode, successCallback) {
        $.ajax({
            url: cip_Common.toApplicationUrl() + '/authentication/sms/activate',
            type: 'POST',
            data: {
                smsCode: smsCode
            },
            handle: function (response) {
                if (response.unexpectedOutcome) {
                    cip_Common.handleUnexpectedOutcome(response);

                } else {
                    window.location.reload();
                }
            }
        });
    };

    cc_EntityIntegration.activateApplicantSessionUsingCustomerDetails = function (email, firstName, lastName, representativeName, successCallback) {
        $.ajax({
            url: cip_Common.toApplicationUrl() + '/authentication/customerdetails/activate',
            type: 'POST',
            data: {
                email: email,
                firstName: firstName,
                lastName: lastName,
                representativeName: representativeName
            },
            handle: function (response) {
                if (response.unexpectedOutcome) {
                    cip_Common.handleUnexpectedOutcome(response);

                } else {
                    window.location.reload();
                }
            }
        });
    };

    cc_EntityIntegration.getSearchDataSourceResults = function (dataSourceReference, searchValue, successCallback) {
        $.ajax({
            type: 'POST',
            url: cip_Common.toApplicationUrl() + '/' + cc_Config.applicationId + '/datasource/search',
            throbber: false,
            data: {
                workflowName: cc_Config.workflowName,
                rulebookName: cc_Config.rulebookName,
                dataSourceReference: cc_Util.stringify(dataSourceReference),
                search: searchValue
            },
            handle: function (response) {
                if (response.unexpectedOutcome) {
                    cip_Common.handleUnexpectedOutcome(response);

                } else {
                    successCallback(response);
                }
            }
        });
    };

    cc_EntityIntegration.startApplication = function (successCallback, parameters) {
        var initialQuestionStates = [];

        var urlParameters = parameters ? parameters : cc_Util.getUrlVars();
        if (urlParameters) {
            $.each(urlParameters, function () {
                var value = urlParameters[this] != null ? urlParameters[this].split("|") : null; // FirstName=Bill%7Ctrue

                if (value) {
                    var initialQuestionState = {
                        id: this
                    };

                    if (value[0]) {
                        initialQuestionState.entered = value[0].split(",");
                    }

                    if (value[1]) {
                        initialQuestionState.disabled = (value[1] === "true");
                    }

                    initialQuestionStates.push(initialQuestionState);
                }
            });
        }

        cc_Ajax.serialRequest({
            url: cip_Common.toApplicationFormUrl(cip_Common.formId) + '/interview/start',
            type: 'POST',
            throbberDelay: 0,
            data: function () {
                return {
                    initialQuestionStates: JSON.stringify(initialQuestionStates)
                }
            },
            handle: function (response) {
                if (response.unexpectedOutcome) {
                    cip_Common.handleUnexpectedOutcome(response);

                } else {
                    successCallback.call(response);
                }
            }
        });
    };

    cc_EntityIntegration.createPreviousButtonText = function (isFirstPageSelected, isLastNonRestrictedPageSelected, isWritableRestrictedPageSelected, isReadyToFinish, isInterviewComplete) {
        return cip_Entity.createPreviousButtonText(cip_Common.brandId, cip_Common.formId, isFirstPageSelected, isLastNonRestrictedPageSelected, isReadyToFinish, isInterviewComplete);
    };

    cc_EntityIntegration.createNextButtonText = function (isFirstPageSelected, isLastNonRestrictedPageSelected, isWritableRestrictedPageSelected, isReadyToFinish, isInterviewComplete) {
        return cip_Entity.createNextButtonText(cip_Common.brandId, cip_Common.formId, isFirstPageSelected, isLastNonRestrictedPageSelected, isReadyToFinish, isInterviewComplete);
    };

    cc_EntityIntegration.createSaveButtonText = function (isFirstPageSelected, isLastNonRestrictedPageSelected, isWritableRestrictedPageSelected, isReadyToFinish, isInterviewComplete) {
        return cip_Entity.createSaveButtonText(cip_Common.brandId, cip_Common.formId, isFirstPageSelected, isLastNonRestrictedPageSelected, isReadyToFinish, isInterviewComplete);
    };

    cc_EntityIntegration.onPreRendering = function () {
        return cip_Entity.onPreRendering(cip_Common.brandId, cip_Common.formId, cc_Config.application);
    };

    cc_EntityIntegration.onPostRendering = function () {
        cip_Entity.onPostRendering(cip_Common.brandId, cip_Common.formId, cc_Config.application);
    };

    cc_EntityIntegration.onPreFindingsAssessment = function (continuation) {
        cip_Entity.onPreFindingsAssessment(cip_Common.brandId, cip_Common.formId, cc_Config.application, function () {
            // hide questions so that response data is not visible when rendered
            $('#container').hide();
            continuation();
        });
    };

    cc_EntityIntegration.onPostFindingsAssessment = function () {
        cip_Entity.onPostFindingsAssessment(cip_Common.brandId, cip_Common.formId, cc_Config.application);
    };

    cc_EntityIntegration.onPostFindingsReassessment = function () {
        cip_Entity.onPostFindingsReassessment(cip_Common.brandId, cip_Common.formId, cc_Config.application);
    };

    cc_EntityIntegration.onCleanAndRefresh = function () {
        cip_Entity.onCleanAndRefresh(cip_Common.brandId, cip_Common.formId, cc_Config.application);
    };

    cc_EntityIntegration.onPostShowPage = function (page) {
        cip_Entity.onPostShowPage(cip_Common.brandId, cip_Common.formId, cc_Config.application, page)
    }

    cc_EntityIntegration.onPostChangedEnteredValue = function (question, updatedEnteredValue) {
        cip_Entity.onPostChangedEnteredValue(cip_Common.brandId, cip_Common.formId, cc_Config.application, question, updatedEnteredValue);
    };
})();